import { Swiper } from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

function openVideo(url) {
  const modal = document.getElementById('videoModal')
  const iframe = document.getElementById('videoFrame')
  iframe.src = url
  modal.style.display = 'block'
}

function closeVideo() {
  const modal = document.getElementById('videoModal')
  const iframe = document.getElementById('videoFrame')
  iframe.src = ''
  modal.style.display = 'none'
}

class VideoSlider {
  constructor($container) {
    this.dataName = {
      list: 'video-container',
      listSlider: 'video-slider',
      listSliderNext: 'video-next',
      listSliderPrev: 'video-prev',
      listSliderPagination: 'video-pagination',
    }

    this.init($container)
  }

  init($container) {
    const $$container = $container || document

    const $listSlider = $$container.querySelectorAll(`[data-${this.dataName.list}]`,)

    console.log($listSlider)

    if (!$listSlider.length) return false

    $listSlider.forEach((el) => {
      const $self = el
      const $slider = $self.querySelector(`[data-${this.dataName.listSlider}]`,)
      const $next = $self.querySelector(`[data-${this.dataName.listSliderNext}]`,)
      const $prev = $self.querySelector(`[data-${this.dataName.listSliderPrev}]`,)
      const $pagintaion = $self.querySelector(`[data-${this.dataName.listSliderPagination}]`,)

      if ($slider) {
        // Уничтожается на разрешении > 991
        const breakpoint = window.matchMedia('(max-width: 640px)')
        const breakpointChecker = function () {
          if (breakpoint.matches === false) {

            if (listSlider !== undefined) {
              listSlider.destroy(true, true)
            }

          } else if (breakpoint.matches === true) {

            return enableSwiper()

          }
        }
        const enableSwiper = function () {
          listSlider = new Swiper($slider, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: false,
            autoHeight: false,
            navigation: {
              nextEl: $next,
              prevEl: $prev,
            },
            pagination: {
              el: $pagintaion,
              type: 'fraction',
            },
          })
        }

        breakpoint.addEventListener('change', breakpointChecker)
        breakpointChecker()

        return false
      }

      let listSlider = new Swiper($slider)
    })
  }
}

$(document).ready(() => {
  if ($('.delegate-video__slider.swiper').length) {
    new VideoSlider()
    console.log('elegate-video__slider init')
  }
})

$(document).on('triggerRutubeSlider', () => {
  new VideoSlider()
  console.log('elegate-video__slider trigger init')
})

$(document).on('triggerRutubeSliderOpenCloseVideo', () => {
  openVideo()
  closeVideo()
  console.log('OpenClose Video')
})
